<script>
  import { t,__,__c } from '../../../utils/i18n';
  import { openFeedbackForm } from '../../../feedbackform';
  import { blockparty } from '../../../utils/copy';

  export let info; 
  
  const cityDict =
  {
    "Unincorporated": `${__("unincorporated areas of Los Angeles county")}`,
    "Industry" : "City of Industry"
  }
  
  function cleanCityName(c) {
    if (cityDict[c] != undefined) {
      let cleanName = cityDict[c];
      return cleanName; 
    } else {
      let cleanName = c;
      return cleanName; 
    }
  }
  
  let cityName = cleanCityName(info.city);
</script>

{#if info.status == 'yes'}
  <p>
    {@html t(blockparty, 'introCity', {
      'id': __(cleanCityName(info.city).capitalize()),
      'verbException': info.city == "Unincorporated" ? __("have") : __("has"), 
    })}
    <a on:click = {openFeedbackForm}>{__("Let us know")}</a> {@html __("about your block party — and read more <a href='https://www.latimes.com/california/story/2023-05-27/how-to-throw-a-block-party-los-angeles-city-county'>here</a>")} 
  </p>
  <h4>{__("Where do I start?")}</h4>
    <p class="answer">
      {@html t(blockparty, 'getStarted', {
        'id': __(cityName),
        'dept': info[__c('department')], 
        'article': cityName == 'Carson' || cityName == 'Burbank' ? '' : `${__("the")}`,
        'permit': info[__c('permit_name')], 
        'days': info[__c('days')], 
        'in_advance': info.days !== 'N/A' && info.days !== 'No response' ? `${__("at least")} ${info[__c('days')]} ${__('days in advance')}.` : '.', //TODO THIS ONE NEEDS THINKING
        'multiple_permits': info.multiple_permits == 'Yes' ? `${__("You may need more than one permit for your party.")}` : '',
      })}
    </p>

  <h4>{__("How can I contact the department?")}</h4>
    <p class="answer">
      {@html t(blockparty, 'contact', {
        'how': info[__c("how")], 
        'website': info.website,
      })}
    </p>

  <h4>{__("How much will it cost?")}</h4>
  <p>
    {@html t(blockparty, 'cost', {
      'cost_assessment': info.permit_fee.includes("$") ? `${__("The permit will cost")}` : `${__("The price of the permit will be")}`, 
      'fee': info[__c('permit_fee')],
    })}
  </p>  

  <h4>{__("Are there any additional costs to consider?")}</h4>
  <p class="answer">
    {@html t(blockparty, 'additionalCosts', {
      'additional_costs': info.additional_costs != 'No response' ? `${info[__c('additional_costs')]}.` : '',
      'additional_costs_notes':  info.additional_costs != 'No' ? `${info[__c('additional_costs_notes')]}` : '', 
    })}
  </p>
  <h4>{__("Will the city help me out?")}</h4>    
    <p class="answer">  
      {@html t(blockparty, 'subsidized', {
      'subsidized': info[__c('subsidized')]
      })}
    </p>
  {:else}
    <p> 
      {@html t(blockparty, 'notAllowed', {
        'id': info.city,
      })}
    </p>
  {/if}